var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-chip',{staticClass:"z-depth-1 rounded",attrs:{"color":"white","close":""},nativeOn:{"click":function($event){return _vm.handleSearchTagClick(_vm.elementId)}}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }